import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm, change } from 'redux-form'
import { bindActionCreators } from 'redux'
import { SubmissionError } from 'redux-form'

import { fetchRemoteActions, addRemoteAction } from '../actions/remoteactions'
import { renderInputField, renderSelectField } from '../utils/forms'

class CriticalActionAddForm extends React.Component {
  constructor(props) {
    super(props)

    this.submit = this.submit.bind(this)
  }

  submit(props) {

    if (!props.arguments || props.arguments === '') {
      throw new SubmissionError({
        arguments: 'No envíes formularios vacíos por favor!'
      });
    }

    props.machine = this.props.machine._id
    props.executor = this.props.fullname

    return this.props.addRemoteAction(props)
      .then(response => {
        if (response.error) {
          throw new SubmissionError({
            _error: response.error.message,
            ...response.error.fields
          })
        }

        this.props.fetchRemoteActions(this.props.machine.Serial)

        return response
      })
  }

  quickAction(code) {
    this.props.dispatch(change('CriticalActionAddForm', 'code', code))
    this.props.dispatch(change('CriticalActionAddForm', 'arguments', 'vacway'))
  }

  render() {
    const { error, pristine, submitting, handleSubmit, machine, fetchRemoteActions } = this.props

    const criticalButtons = [
      { code: 'DOWNLOAD_MATRIX', label: 'Enviar Matriz',   icon: 'fa-keyboard',  color: '#dc2626' },
      { code: 'SEND_LASTSALE',   label: 'Enviar Lastsale', icon: 'fa-euro-sign', color: '#dc2626' },
    ]

    return (
      <div className="od-remote-inner">
        {/* Quick action buttons */}
        <div className="od-remote-quick">
          <div className="od-remote-section-title">
            <i className="fas fa-bolt"></i> Acciones rápidas
          </div>
          <div className="od-remote-btn-group-label critical" style={{ marginBottom: '8px' }}>
            <i className="fas fa-exclamation-triangle"></i> Críticas
          </div>
          <div className="od-remote-btn-row">
            {criticalButtons.map(btn => (
              <button
                key={btn.code}
                type="button"
                className="od-remote-btn"
                style={{ '--btn-color': btn.color }}
                onClick={() => this.quickAction(btn.code)}
              >
                <span className="od-remote-btn-icon">
                  <i className={`fas ${btn.icon}`}></i>
                </span>
                <span className="od-remote-btn-label">{btn.label}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Advanced form */}
        <div className="od-remote-form-wrap">
          <div className="od-remote-section-title">
            <i className="fas fa-terminal"></i> Formulario avanzado
          </div>
          <div className="od-remote-alert">
            <i className="fas fa-exclamation-triangle"></i>
            Selecciona acciones directamente del formulario solo si sabes lo que haces, si no utiliza los botones predefinidos.
          </div>
          <form onSubmit={handleSubmit(this.submit)} className="od-remote-form">
            <div className="od-remote-fields-row">
              <Field name="code" component={renderSelectField}>
                <option value="">Selecciona una acción...</option>
                <optgroup label="Críticas">
                  <option value="DOWNLOAD_MATRIX">Enviar Matriz</option>
                  <option value="SEND_LASTSALE">Enviar Lastsale</option>
                </optgroup>
                <optgroup label="Avanzadas">
                  <option value="COMMAND">(Updater) Ejecutar comando</option>
                  <option value="APP_UPDATE">Actualizar APP</option>
                  <option value="ESP32_OTA">Actualizar ESPRESSIF</option>
                  <option value="U1000_UPDATE">Actualizar U1000</option>
                  <option value="KERONG_OTA">Actualizar KERONG</option>
                  <option value="BOOTLOADER_OTA">Actualizar BOOTLOADER</option>
                  <option value="KERONG_PROGRAM_DOWNLOAD">KERONG Descargar Programa</option>
                  <option value="KERONG_BOOTLOADER_DOWNLOAD">KERONG Descargar Bootloader</option>
                  <option value="SINGLE_COMMAND">(APP) Comando de terminal</option>
                </optgroup>
              </Field>
              <Field name="arguments"
                type="text"
                component={renderInputField}
                placeholder="Argumentos" />
            </div>
            <div className="od-remote-form-actions">
              <button className="od-remote-submit" type="submit" disabled={pristine || submitting}>
                <i className="fas fa-bolt"></i> Ejecutar
              </button>
              <button className="od-remote-refresh" type="button" onClick={() => fetchRemoteActions(machine.Serial)}>
                <i className="fas fa-sync"></i> Actualizar
              </button>
            </div>
            {error && <div className="od-remote-error">{error}</div>}
          </form>
        </div>
      </div>
    )
  }
}

CriticalActionAddForm = reduxForm({
  form: 'CriticalActionAddForm',
})(CriticalActionAddForm)

const mapStateToProps = state => ({
  auth: state.auth,
  role: state.auth.role,
  type: state.auth.type,
  fullname: state.auth.fullname,
})

const mapDispatchToProps = dispatch => ({
  addRemoteAction: bindActionCreators(addRemoteAction, dispatch),
  fetchRemoteActions: bindActionCreators(fetchRemoteActions, dispatch),
  dispatch,
})

export default connect(mapStateToProps, mapDispatchToProps)(CriticalActionAddForm)
